const StockTransferIndex = () => import('./stock-deliveries/index.vue');
const CreateStockTransfer = () => import('./stock-deliveries/_pages/create.vue');
const ViewStockTransfer = () => import('./stock-deliveries/_pages/view.vue');
const TransferDeliveries = () => import('./stock-deliveries/_pages/parent-list.vue');
const TransferProductsList = () => import('./stock-deliveries/_pages/products-list.vue');

const TransferDrafts = () => import('./transfer-drafts/index.vue');
const CreateTransferDraft = () => import('./transfer-drafts/_pages/create.vue');
const EditTransferDraft = () => import('./transfer-drafts/_pages/view.vue');
const CopyTransferDraft = () => import('./transfer-drafts/_pages/copy.vue');

// incoming transfers
const IncomingTransferIndex = () => import('./incoming-transfers/index.vue');
const ViewIncomingTransfer = () => import('./incoming-transfers/_pages/view.vue');

const InterCodeTransfer = () => import('./inter-code-transfers/index.vue');
const InterBranchTransfer = () => import('./inter-branch-transfer/index.vue');

const TransferPerProduct = () => import('./transfer-per-product.vue');

export default [
    {
        path: '/stock-transfer-per-product',
        component: TransferPerProduct
    },
    {
        path: '/inter-branch-transfer',
        component: InterBranchTransfer
    },
    {
        path: '/stock-transfer',
        component: StockTransferIndex
    },
    {
        path: '/create-stock-transfer',
        component: CreateStockTransfer
    },
    {
        path: '/stock-transfer/:id',
        component: ViewStockTransfer
    },
    {
        path: '/transfer-drafts',
        component: TransferDrafts
    },
    {
        path: '/create-transfer-draft',
        component: CreateTransferDraft
    },
    {
        path: '/edit/transfer/draft/:id',
        component: EditTransferDraft
    },
    {
        path: '/copy/transfer/:id',
        component: CopyTransferDraft
    },
    {
        path: '/transfer-deliveries',
        component: TransferDeliveries
    },
    {
        path: '/transfer-products-list',
        component: TransferProductsList
    },
    {
        path: '/incoming-transfers',
        component: IncomingTransferIndex
    },
    {
        path: '/incoming-transfers/:id',
        component: ViewIncomingTransfer
    },
    {
        path: '/inter-code-transfers',
        component: InterCodeTransfer
    },
];